'use strict'

module.exports = {
  SHA1: 20,
  SHA256: 32,
  SHA512: 64
}



//////////////////
// WEBPACK FOOTER
// ./~/libp2p-crypto/src/crypto/hmac-lengths.js
// module id = 259
// module chunks = 0